import {NakdanType, SimpleVsProConfig} from '@/simpleVsProConfig.js'
import {RunStates} from './runStates'

import {getGitCommitId} from '../js/getGitCommitId'

const LATEST_VERSION = '1.3 - git commit: ' + getGitCommitId()

export const StateSaver = {
  saveState: (stateToSave) => {
    const copyOfStateToSave = Object.assign({}, stateToSave, { version: LATEST_VERSION })
    delete copyOfStateToSave.validationResult
    window.localStorage.setItem(NakdanType.SavedStateName, JSON.stringify(copyOfStateToSave))
  }
}

export const StateChanges = {
  // ** front end *
  SET_ENTIRE_STATE: 'SET_ENTIRE_STATE',
  LOAD_DOCUMENT_FILE: 'LOAD_DOCUMENT_FILE',
  EDIT_DOCUMENT_TEXT: 'EDIT_DOCUMENT_TEXT',
  SET_TEXT_FOR_NAKDAN_API_CALL: 'SET_TEXT_FOR_NAKDAN_API_CALL',
  STORE_ALL_FRONTEND_NIKUD_OPTIONS: 'STORE_ALL_FRONTEND_NIKUD_OPTIONS',
  STORE_ALL_WORKING_NIKUD: 'STORE_ALL_WORKING_NIKUD',
  REWRITE_WORD_IN_WORKING_ARRAY: 'REWRITE_WORD_IN_WORKING_ARRAY',
  REWRITE_WORD_TO_RUN_AND_POS_MAP: 'REWRITE_WORD_TO_RUN_AND_POS_MAP',
  SPLICE_WORDS_IN_WORKING_ARRAY: 'SPLICE_WORDS_IN_WORKING_ARRAY',
  SET_CURRENT_WORD_INDEX: 'SET_CURRENT_WORD_INDEX',
  SET_CURRENT_LETTER_INDEX: 'SET_CURRENT_LETTER_INDEX',
  SET_WORD_AND_LETTER: 'SET_WORD_AND_LETTER',
  SET_SHOW_AIMS: 'SET_SHOW_AIMS',
  SET_NIKUD_KEYBOARD: 'SET_NIKUD_KEYBOARD',
  SET_SHOW_NIKUD_BUTTONS: 'SET_SHOW_NIKUD_BUTTONS',
  SET_DISABLE_GO_HOME_PROMPT: 'SET_DISABLE_GO_HOME_PROMPT',
  SET_DISABLE_BACK_TO_TEXT_PREP_PROMPT: 'SET_DISABLE_BACK_TO_TEXT_PREP_PROMPT',
  SET_DISABLE_SWITCH_GENRE_PROMPT: 'SET_DISABLE_SWITCH_GENRE_PROMPT',
  SET_ALL_POST_SUBMISSION_OPTIONS: 'SET_ALL_POST_SUBMISSION_OPTIONS',
  VALIDATION_FAILURE_POPUP_SHOWN: 'VALIDATION_FAILURE_POPUP_SHOWN',
  // the front end "state changes" immediately below are used only in the "Pro" Nakdan
  UPDATE_USER_DICTIONARY: 'UPDATE_USER_DICTIONARY',
  SET_DISABLE_UPLOAD_DICTIONARY_PROMPT: 'SET_DISABLE_UPLOAD_DICTIONARY_PROMPT',

  // ** concerning APIs *
  NAKDAN_RUNNING: 'NAKDAN_RUNNING',
  NAKDAN_TIMED_OUT: 'NAKDAN_TIMED_OUT',
  NAKDAN_FAILED: 'NAKDAN_FAILED',
  SET_NAKDAN_RESULTS: 'SET_NAKDAN_RESULTS',
  GENRE_CLASSIFY_RUNNING: 'GENRE_CLASSIFY_RUNNING',
  GENRE_CLASSIFY_TIMED_OUT: 'GENRE_CLASSIFY_TIMED_OUT',
  GENRE_CLASSIFY_FAILED: 'GENRE_CLASSIFY_FAILED',
  SET_GENRE_CLASSIFY_RESULTS: 'SET_GENRE_CLASSIFY_RESULTS',

  // ** from firebase * (all these firebase-related "state changes" are used only in the "Pro" Nakdan")
/*SET_SAVE_MESSAGE: 'SET_SAVE_MESSAGE',
  RESET_SAVE_MESSAGE: 'RESET_SAVE_MESSAGE',
  UPDATE_SAVED_TEXTS: 'UPDATE_SAVED_TEXTS',
  UPDATE_SAVED_EXPERIMENTS: 'UPDATE_SAVED_EXPERIMENTS',*/
  FIREBASE_RECEIVED_UPDATE: 'FIREBASE_RECEIVED_UPDATE',
  CHANGE_USER_PASSWORD: 'CHANGE_USER_PASSWORD',
  LOGIN_REQUESTED: 'LOGIN_REQUESTED',
  LOGIN_CONTINUING: 'LOGIN_CONTINUING',
  LOGIN_COMPLETE: 'LOGIN_COMPLETE',
  LOGIN_CANCELLED: 'LOGIN_CANCELLED',
  LOGGED_OUT: 'LOGGED_OUT',
/*SAVE_FAVORITE: 'SAVE_FAVORITE',
  DELETE_FAVORITE: 'DELETE_FAVORITE',
  SAVE_EXPERIMENT: 'SAVE_EXPERIMENT',
  UNSAVE_EXPERIMENT: 'UNSAVE_EXPERIMENT'*/

}

export const Actions = {
  INITIALIZE_APPLICATION: 'INITIALIZE_APPLICATION',
  RUN_NAKDAN: 'RUN_NAKDAN',
  // the remaining "actions" are used only in the "Pro" Nakdan
  PROCESS_LOGIN: 'PROCESS_LOGIN',
  LOGOUT: 'LOGOUT'

  // LOAD_EXPERIMENT: 'LOAD_EXPERIMENT',

  // ** from firebase *
  // SET_SAVE_RESULT: 'SET_SAVE_RESULT'

}

export const BlankState = {
  validationResult: null,
  firstTimeInitialized: true,
  preSubmissionOptions: {
    nikudType: 'auto',
    chosenTextTypeName: 'modern',
    // options below here are used only by the 'Pro' Nakdan
    skipLetters: false,
    skipAbbrevs: false,
    skipParens: false,
    skipBrackets: false,
    skipBraces: false,
    skipVoc: false,
    skipPartVoc: false,
    splitParens: false,
    dageshOnlyIfHeard: false,
    ketivMaleh: false,
    useQamatzQatan: false,
    keepSourceDagesh: false,
    mahPatachDagesh: false
  },
  nakdanApiState: RunStates.NOT_RUN,
  genreClassifyApiState: RunStates.NOT_RUN,
  originalDocument: {
    id: -0.1,
    text: '',
    source: {
      fileBase64Contents: null,
      type: null,
      runArray: [],
      wordToRunAndPosMap: []        
    },
    identifiedGenre: null
  },
  textForNakdanApiCall: {
    text: ''
  },
  nakdanApiResponse: [],
  allWorkingNikud: {
    id: -0.01,
    wordsArray: [],
    lastWordId: -1
  },
  wordIdToIndexMap: {},
  currentPositionData: {
    wordIndex: -1,
    letterIndex: -1
  },
  postSubmissionOptions: {
    showAims: false,
    nikudKeyboard: 'new',
    showNikudButtons: SimpleVsProConfig.NIKUD_BUTTONS.SHOW_BY_DEFAULT,
    disableGoHomePrompt: false,
    disableBackToTextPrepPrompt: false,
    disableSwitchGenrePrompt: false,
  // the rest of "BlankState" (below here) is used only in the "Pro" Nakdan
    disableUploadDictionaryPrompt: false
  },
  userDictionary: {
    entryPresent: {},
    lettersMap: {},
    negativeEntryPresent: {},
    negativeLettersMap: {}
},
/* login */
  isLoggedIn: false,
  userData: null,
  loginInProgress: false
}
